exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#bodyDialogInfo[data-v-65a7887c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  overflow-y: auto;\n}\n.itemInfoDiv[data-v-65a7887c] {\n  margin-bottom: 15px;\n  font-size: 1.2rem;\n}\n", ""]);

// exports
